/**
 * Pure component for the Password reveal view (second page of the New User
 * app)
 */

import React from 'react';
import PropTypes from 'prop-types';
import { List } from 'immutable';

import { isNumber } from 'phoenix2/utils';
import NewUserButton from './common/new-user-button';

export default class PasswordRevealView extends React.Component {
    static displayName = 'PasswordRevealView';

    static propTypes = {
        // The user's new password to be displayed
        newPassword: PropTypes.string.isRequired,

        // The user's first name:
        firstName: PropTypes.string,

        // The user's last name:
        lastName: PropTypes.string,

        // The user's username:
        username: PropTypes.string,

        // Callback for when the user finishes viewing the password
        onFinish: PropTypes.func.isRequired,
    };

    render() {
        const { firstName, lastName, username, onFinish } = this.props;

        let name = null;
        if (firstName) {
            name = firstName + (lastName ? ' ' + lastName : '');
        }

        return (
            <div className="new-user-reveal-password-page">
                <div className="new-user-view-content">
                    <div className="new-user-view-box">
                        <div className="new-user-username-reveal-header">
                            {name ? name + ', the ' : 'The '}
                            details for your Sparx account are:
                        </div>

                        <div className="new-user-password-reveal-container">
                            <p className="new-user-password-reveal-label">Your username is:</p>
                            <div className="new-user-username-reveal">{username}</div>

                            <p className="new-user-password-reveal-label">Your password is:</p>
                            <div className="new-user-password-reveal">{this._getPassword()}</div>

                            <div className="new-user-password-reveal-footer">
                                <div>Keep these details safe!</div>

                                <div>
                                    <strong>
                                        This is the only time you will be told these details.
                                    </strong>
                                </div>

                                <div>
                                    When you&rsquo;ve remembered your details, click
                                    &lsquo;Finish&rsquo;.
                                </div>
                            </div>
                        </div>

                        <div className="new-user-view-form-button-group">
                            <NewUserButton
                                type="submit"
                                value="Finish"
                                handleClick={() => onFinish()}
                            />
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    /**
     * Split a password up in to spans of consecutive numbers / letters
     * @private
     */
    _getPassword() {
        const { newPassword } = this.props;

        let parts = List();
        let currentPartType = null;
        let currentPart = '';
        let count = 0;

        const makePart = () => {
            if (!currentPart) {
                return;
            }
            parts = parts.push(
                <span key={count++} className={'password-' + currentPartType}>
                    {currentPart}
                </span>,
            );
            currentPart = '';
            currentPartType = null;
        };

        for (let i = 0; i < newPassword.length; i++) {
            const char = newPassword.charAt(i);
            const type = isNumber(char) ? 'digit' : 'letter';
            if (type === currentPartType) {
                currentPart += char;
            } else {
                makePart();
                currentPart = char;
                currentPartType = type;
            }
        }
        makePart();

        return parts;
    }
}
